import { procurementAPI } from "../../axios";

export const actions = {
  // ApiResource
  GetResourceItemByAPI(context, data) {
    return procurementAPI.get(`ApiResource/${data.apiId}/${data.bli}`);
  },
  GetAllResourceByAPI(context, data) {
    return procurementAPI.get(`ApiResource/all/${data}`);
  },
  GetAllResourceByCampus(context, data) {
    return procurementAPI.get(`ApiResource/Campus/${data.campusId}/${data.cycle}`);
  },
  GetAllResourceByDU(context, data) {
    return procurementAPI.get(`ApiResource/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
  },
  GetAllResourcesByDUSimplified(context, data) {
    return procurementAPI.get(`ApiResource/Simplified/${data.deliveryUnitId}/${data.cycle}`);
  },
  GetAllSummaryResourceByDU(context, data) {
    return procurementAPI.get(`ApiResource/Summary/${data.deliveryUnitId}/${data.cycle}`);
  },
  GetAllResourceByDepartment(context, data) {
    return procurementAPI.get(`ApiResource/DeliveryUnit/${data.departmentId}/${data.cycle}`);
  },
  GetResourceProgress(context, data) {
    return procurementAPI.get(`ApiResource/Progress/${data}`);
  },
  GetSinglePPMPItem(context, data) {
    return procurementAPI.get(`ApiResource/${data}`);
  },
  UpdatePPMPItem(context, data) {
    return procurementAPI.put(`ApiResource/${data.id}`, data);
  },
  UpdatePPMPSomeItem(context, data) {
    return procurementAPI.put(`ApiResource/Update/SomeFields/${data.apiResourceId}`, data);
  },
  DeletePPMPItem(context, data) {
    return procurementAPI.delete(`ApiResource/${data}`);
  },
  CreatePPMPItem(context, data) {
    return procurementAPI.post(`ApiResource/CreateApiResource`, data);
  },
  CreateMultiplePPMPItem(context, data) {
    return procurementAPI.post(`ApiResource/Create/Multiple`, data);
  },
  ResubmitPPMPItem(context, data) {
    return procurementAPI.put(`ApiResource/Resubmit/${data}`);
  },
  GetResourceItemByBudget(context, data) {
    return procurementAPI.get(`ApiResource/BudgetItem/${data}`);
  },
  GetResourceItemByBudgetSummary(context, data) {
    return procurementAPI.get(`ApiResource/BudgetItem/Summary/${data}`);
  },
  TransferResource(context, data) {
    return procurementAPI.post(`ApiResource/Transfer`, data);
  },
  ImportResource(context, data) {
    return procurementAPI.post(`ApiResource/Import`, data);
  },
  TraceItem(context, data) {
    return procurementAPI.put(`ApiResource/Trace/${data.id}/${data.IsNotify}`);
  },
  AllowPR(context, data) {
    return procurementAPI.put(`ApiResource/AllowPr/${data.id}?allowPr=${data.pr}`);
  },
  AllowPRMultiple(context, data) {
    return procurementAPI.put(`ApiResource/Allow/PR/Multiple`, data);
  },
  MovePRToCampusMultiple(context, data) {
    return procurementAPI.put(`ApiResource/AddToCampusPR/Multiple`, data);
  },
  RemoveCampusPR(context, data) {
    return procurementAPI.put(`ApiResource/CampusPr/Remove/${data}`);
  },
  ResetToTechRep(context, data){
    return procurementAPI.put(`ApiResource/TechnicalReviewStatus/Pending/${data}`);
  },
  GetProcurableApiResource(context, data){
    return procurementAPI.get(`ApiResource/Procurable/${data}`);
  }
};
